<template>
    <div class="boxTop">
        <h1>{{ obj.header }}</h1>
        <div class="line"></div>
        <div class="card">
            <div v-for="(item, index) in obj.arrCard" :key="index">
                <p>{{ item.num }}</p>
                <p>{{ item.name }}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        obj:{
            type:Object,
            // vue接收数组或者对象的时候必须从工厂函数中获取
            default:()=>{
                return {
                header: "热力数据",
                arrCard: [
                    {
                        name: "供热范围 (个)",
                        num: 1
                    },
                    {
                        name: "供热面积 (m²)",
                        num: 1429.62
                    },
                    {
                        name: "建筑面积 (m²)",
                        num: 1160.81
                    },
                    {
                        name: "供暖率 (%)",
                        num: 88.24
                    }
                ]
            }
            }
        }
    },
    data() {
        return{
           
        }
    },
}
</script>
<style lang="less" scoped>
/*引入字体*/
@font-face{
    /*自定义文字名称*/
    font-family: "yj";
    /*字体文件的路径*/
    src: url("./1.TTF");
}
.boxTop::v-deep{
    height: 140px;
    h1 {
        margin: 15px 18px 0px;
        height: 25px;
        font-size: 18px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 25px;
        text-shadow: 0px 0px 8px #005EC9;
    }
    .line{ 
        height: 13px;
        background-image: url(@/assets/images/cockpit/title2.png);
        background-size: contain;
        background-repeat: no-repeat;
    }
    .card {
        display: flex;
        margin-top: 23px;
        justify-content: space-between;
        div {

            margin: 0 1%;
            text-align: center;
            p{
                text-align: center;
                
                &:nth-child(1){
                    
                    height: 31px;
                    /*使用刚才定义的字体名称*/
                    font-family: yj;
                    font-size: 35px;
                    font-weight: normal;
                    color: #00FFF2;
                    line-height: 31px;
                }
                &:nth-child(2){
                    display: inline-block;
                    width: 64px;
                    color: rgba(255,255,255,0.5);
                    font-size: 14px;
                    font-weight: 700;
                    color: #8FA4CC;
                    line-height: 22px;
                    text-shadow: 0px 0px 8px #005EC9;
                }
            }
        }
    }
}
</style>